import React, { useState, useRef, useEffect, useMemo, useContext, useCallback } from "react";
import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Select from "react-select";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

import { getData, postDataWithBody } from "../../../Services/Services";
import { toast } from "react-toastify";
import {
  findAllChildrenRegionsById,
  getcensusdatain,
  geteventdetails,
  geteventincidentdata,
  getfacilitydatasearch,
  getfacilitytabledata,
  getGisData,
  getincidentDatain,
  getregionincidentdata,
  getresourceData,
  getsearchdetails,
  getshowbasicdet,
  gisCoordinatesData,
  gisBlockCoordinatesData,
  gisStateCoordinates,
  ladakhDistrictsInGis,
  resourcedistance,
  searchshowlatdetails,
  supportPoints,
  updateincidentForLadakh,
  getThemeURL,
  getPastDaysWeatherData,
  getSopInstanceSummaryByState,
  getSopInstanceSummaryByIncident,
} from "../../../Services/EndPoints";
import { Search, MapPin, AlertTriangle, Cloud, Link2, ChevronRight, Users, FileText, Camera, Truck, PackageCheck, PlayCircle, XCircle, CheckCircle2 } from "lucide-react";

import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import myImage from "../../../Assets/Images/tableview.png";
import logo from "../../../Assets/Icons/CircleDashed.svg";
import logo1 from "../../../Assets/Icons/Polygon.svg";
import Tree from "rc-tree";
import RegionNode from "../RegionManagement/RegionList/RegionTree/RegionNode";
import RMMap from "../RegionManagement/RMMap/RMMap";
import { useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../..";


// ──── Weather imports ────
import { fetchWeatherForRegions } from "../RegionManagement/RMMap/WeatherService";
import WeatherPanel from "../RegionManagement/RMMap/WeatherPanel";
import {
  facilityIconConfigs,
  buildFacilityPopupHtml,
} from "../RegionManagement/RMMap/GoogleMapsUtils";
import DashboardMap from "../Dashboard/DashboardMap";
import RecentAlerts from "../Dashboard/Weatheralerts";

const STATE_CAPITALS = {
  "ladakh": { name: "Leh", lat: 34.1526, lng: 77.5771 },
  "bihar": { name: "Patna", lat: 25.6093, lng: 85.1376 },
  "jammu and kashmir": { name: "Srinagar", lat: 34.0837, lng: 74.7973 },
  "himachal pradesh": { name: "Shimla", lat: 31.1048, lng: 77.1734 },
  "uttarakhand": { name: "Dehradun", lat: 30.3165, lng: 78.0322 },
  "uttar pradesh": { name: "Lucknow", lat: 26.8467, lng: 80.9462 },
  "rajasthan": { name: "Jaipur", lat: 26.9124, lng: 75.7873 },
  "punjab": { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
  "haryana": { name: "Chandigarh", lat: 30.7333, lng: 76.7794 },
  "delhi": { name: "New Delhi", lat: 28.6139, lng: 77.2090 },
  "gujarat": { name: "Gandhinagar", lat: 23.2156, lng: 72.6369 },
  "maharashtra": { name: "Mumbai", lat: 19.0760, lng: 72.8777 },
  "madhya pradesh": { name: "Bhopal", lat: 23.2599, lng: 77.4126 },
  "odisha": { name: "Bhubaneswar", lat: 20.2961, lng: 85.8245 },
  "west bengal": { name: "Kolkata", lat: 22.5726, lng: 88.3639 },
  "assam": { name: "Dispur", lat: 26.1433, lng: 91.7898 },
  "karnataka": { name: "Bengaluru", lat: 12.9716, lng: 77.5946 },
  "telangana": { name: "Hyderabad", lat: 17.3850, lng: 78.4867 },
  "tamil nadu": { name: "Chennai", lat: 13.0827, lng: 80.2707 },
  "kerala": { name: "Thiruvananthapuram", lat: 8.5241, lng: 76.9366 },
};
const getCapitalForState = (name) => {
  if (!name) return null;
  return STATE_CAPITALS[name.toLowerCase().trim()] || null;
};


const GisMapview = () => {
  const [incidentMarkerData, setIncidentMarkerData] = useState(null);
  const [incidentBlockIds, setIncidentBlockIds] = useState([]);
  const handle = useFullScreenHandle();
  const [supportPointsData, setSupportPointsData] = useState([]);
  const [showRegionHierarchy, setShowRegionHierarchy] = useState(true);
  const [showfacilityHierarchy, setShowfacilityHierarchy] = useState(true);
  const [showresourcedata, setshowresourcedata] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [enabledConditions, setEnabledConditions] = useState([]);
  const [activeHeatmapCondition, setActiveHeatmapCondition] = useState(null);
  const [heatmapGridData, setHeatmapGridData] = useState([]);
  const [heatmapLoading, setHeatmapLoading] = useState(false);

  // ── Alert-specific boundary data (separate from region tree selections) ──
  const [alertDistrictGeoJSON, setAlertDistrictGeoJSON] = useState([]);
  const [alertBlockGeoJSON, setAlertBlockGeoJSON] = useState([]);
  const [alertBoundariesLoading, setAlertBoundariesLoading] = useState(false);
  const [alertBoundariesLoaded, setAlertBoundariesLoaded] = useState(false);

  const [kilometerRange, setKilometerRange] = useState(100);
  const [storedIncidentData, setStoredIncidentData] = useState({
    panchayatIds: [],
    blockIds: [],
    supportPoints: [],
    incidentMarkerData: null,
  });

  const [DistrictList, setDistrictList] = useState([]);
  const [selectAllState, setSelectAllState] = useState(true);
  const [facilitySearchTerm, setFacilitySearchTerm] = useState("");
  const [showmodel, setshowmodel] = useState(false);
  const [showIncident, setShowIncident] = useState(false);
  const [selectedIncidentId, setSelectedIncidentId] = useState("");
  const [showClearIncidentConfirm, setShowClearIncidentConfirm] = useState(false);
  const [capturingScreenshot, setCapturingScreenshot] = useState(false);
  const [sopInstanceSummary, setSopInstanceSummary] = useState(null);
  const [sopSummaryLoading, setSopSummaryLoading] = useState(false);

  const captureScreen = async () => {
    if (!handle.node?.current || capturingScreenshot) return;
    if (!navigator.mediaDevices?.getDisplayMedia) {
      toast.error("Your browser doesn't support screen capture. Please use your OS screenshot tool.");
      return;
    }
    setCapturingScreenshot(true);
    let stream = null;
    try {
      // html2canvas can't export Google Maps tiles — the cross-origin tile
      // images taint the cloned canvas and canvas.toDataURL() throws.
      // getDisplayMedia instead grabs the actual composited frame the same
      // way a screen recorder would, so it isn't subject to that restriction
      // at all. Chrome's preferCurrentTab pre-selects "this tab" in the
      // native share prompt so it's effectively one click there; other
      // browsers still show their normal picker.
      stream = await navigator.mediaDevices.getDisplayMedia({
        video: { displaySurface: "browser" },
        preferCurrentTab: true,
        audio: false,
      });

      const video = document.createElement("video");
      video.srcObject = stream;
      await video.play();
      // Let a couple of frames actually paint before grabbing one.
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

      // Crop the captured frame down to just the GIS panel. Chrome's "this
      // tab" capture reports the stream at the tab's actual device-pixel
      // size, so devicePixelRatio (not a ratio derived from window.innerWidth)
      // is the correct, standard way to map the panel's CSS-pixel bounding
      // rect onto that stream's pixel coordinates.
      const dpr = window.devicePixelRatio || 1;
      const rect = handle.node.current.getBoundingClientRect();
      let sx = Math.max(0, rect.left * dpr);
      let sy = Math.max(0, rect.top * dpr);
      let sw = Math.min(rect.width * dpr, video.videoWidth - sx);
      let sh = Math.min(rect.height * dpr, video.videoHeight - sy);
      // If the math doesn't land inside the actual frame (e.g. "Entire
      // Screen" or "Window" was shared instead of "This Tab", so the stream
      // isn't just the tab's own pixels), fall back to the full frame rather
      // than producing an empty/invalid crop.
      if (sw <= 0 || sh <= 0) {
        sx = 0; sy = 0; sw = video.videoWidth; sh = video.videoHeight;
      }

      const canvas = document.createElement("canvas");
      canvas.width = Math.round(sw);
      canvas.height = Math.round(sh);
      canvas.getContext("2d").drawImage(video, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);

      const dataUrl = canvas.toDataURL("image/png");
      const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = `GIS_Map_View_${stamp}.png`;
      a.click();
    } catch (error) {
      console.error("Screen capture failed:", error);
      if (error?.name === "NotAllowedError") {
        toast.info("Screen capture was cancelled.");
      } else {
        toast.error("Couldn't capture the screen. Please try your OS screenshot tool.");
      }
    } finally {
      stream?.getTracks().forEach((t) => t.stop());
      setCapturingScreenshot(false);
    }
  };
  const [selectincideregionid, setSelectedincidentregionid] = useState("");
  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [regionTypeId, setRegionTypeId] = useState(null);
  const [expandedKeys, setExpandedKeys] = useState(["53"]);
  const [actionType, setActionType] = useState("");
  const [keyVal, setKeyVal] = useState("");
  const [actionTypeHeader, setActionTypeHeader] = useState("");
  const [id, setId] = useState(null);
  const [districtId, setDistrictId] = useState("");
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedBlockIds, setSelectedBlockIds] = useState([]);
  const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
  const [selectedVillageIds, setSelectedVillageIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [censusSearchTerm, setCensusSearchTerm] = useState("");
  const [regionSearchTerm, setRegionSearchTerm] = useState("");
  const [eventSearchTerm, setEventSearchTerm] = useState("");
  const [drawCircle, setDrawCircle] = useState(false);
  const [activeDrawTool, setActiveDrawTool] = useState(null); // null | "circle" | "polygon"
  const [circleRadius, setCircleRadius] = useState(0);
  const [clearCircles, setClearCircles] = useState(false);
  const [facilityCoordinates, setFacilityCoordinates] = useState([]);
  const [filteredFacilities, setFilteredFacilities] = useState([]);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isKilometerEnabled, setIsKilometerEnabled] = useState(false);
  let tabvv = state?.tabvv;
  let inciden_mapid = state?.id;
  const [clickedPoint, setClickedPoint] = useState(null);
  const [activeTab, setActiveTab] = useState(tabvv ? "Incident" : "Region");
  const regionDataMap = useRef(new Map()).current;

  const [mapData, setMapData] = useState({
    branches: [],
    atms: [],
    incidents: [],
    events: [],
  });
  const [facilities, setFacilities] = useState([]);
  const [searchCoordinates, setSearchCoordinates] = useState(null);
  const [facilityData, setFacilityData] = useState([]);
  const [resourcedata, setResourcedata] = useState([]);
  const [incidentdata, setincidentdata] = useState([]);
  const [expandedSections, setExpandedSections] = useState({
    attribute: true,
    regions: true,
    events: true,
  });
  const [basicindata, setbasicindata] = useState([]);
  const [censusdata, setcensusdata] = useState([]);
  const [regiondata, setregiondata] = useState([]);
  const [eventdata, seteventdata] = useState([]);
  const [drawPolygon, setDrawPolygon] = useState(false);
  const [clearPolygons, setClearPolygons] = useState(false);
  const { theme } = useContext(ThemeContext);

  // ──── Weather state ────
  const [weatherData, setWeatherData] = useState([]);
  const [weatherLoading, setWeatherLoading] = useState(false);
  const [weatherDropdownOptions, setWeatherDropdownOptions] = useState([]);
  const [selectedWeatherRegion, setSelectedWeatherRegion] = useState("");
 const today_init = new Date().toISOString().split("T")[0];
const [weatherFilterDate, setWeatherFilterDate] = useState(today_init);
const [isPastDate, setIsPastDate] = useState(false);
const [pastHourlyData, setPastHourlyData] = useState([]);
  const [weatherBoundaryGeoJson, setWeatherBoundaryGeoJson] = useState(null);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [forecastHourly, setForecastHourly] = useState([]);
const [forecastDaily, setForecastDaily] = useState([]);
const [forecastLoading, setForecastLoading] = useState(false);
const [stateId, setStateId] = useState(null);
const [statename, setStatename] = useState(null);

// ──── Alerts tab weather state ────
const [alertsWeatherData, setAlertsWeatherData] = useState({});
const [alertsWeatherLoading, setAlertsWeatherLoading] = useState(false);
const [alertsCapitalName, setAlertsCapitalName] = useState("");



const getUserProfile = async () => {
  try {
    const profile = await getData(getThemeURL);
    if (profile && profile.length > 0) {
      setStateId(profile[0].state_id);
      setStatename(profile[0].statename)
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
  }
};

const fetchAlertsWeather = useCallback(async (sName) => {
  const capital = getCapitalForState(sName);
  const coords = capital || { lat: 34.1526, lng: 77.5771 };
  setAlertsCapitalName(capital?.name || "");
  setAlertsWeatherLoading(true);
  try {
    const res = await fetch(
      `https://weather.googleapis.com/v1/currentConditions:lookup?key=${GOOGLE_WEATHER_API_KEY}&location.latitude=${coords.lat}&location.longitude=${coords.lng}`
    );
    const json = await res.json();
    if (!json || json.error) throw new Error(json?.error?.message || "Weather fetch failed");
    setAlertsWeatherData({
      temperature: json.temperature?.degrees ?? null,
      humidity: json.relativeHumidity ?? null,
      windspeed: json.wind?.speed?.value ?? null,
      winddirection: json.wind?.direction?.degrees ?? null,
      rain: json.precipitation?.probability?.percent ?? null,
      thunder: json.thunderstormProbability ?? json.precipitation?.probability?.percent ?? null,
      pressure: json.airPressure?.meanSeaLevelMillibars ?? null,
      visibility: json.visibility?.distance ?? null,
      uv: json.uvIndex ?? null,
      dewpoint: json.dewPoint?.degrees ?? null,
    });
  } catch (e) {
    console.error("[Alerts Weather] Fetch failed:", e);
    setAlertsWeatherData({});
  } finally {
    setAlertsWeatherLoading(false);
  }
}, []);

useEffect(() => {
  if (activeTab === "Alerts" && statename) {
    fetchAlertsWeather(statename);
  }
}, [activeTab, statename, fetchAlertsWeather]);

const isToday = (dateStr) => {
  if (!dateStr) return true;
  return dateStr === new Date().toISOString().split("T")[0];
};


const loadAlertBoundaries = useCallback(async () => {
    if (alertBoundariesLoaded || alertBoundariesLoading) return;
    if (!stateId) return;
    setAlertBoundariesLoading(true);

    try {
      const districtsList = await postDataWithBody(
        findAllChildrenRegionsById,
        [stateId],
        {}
      );
      if (!districtsList || !Array.isArray(districtsList)) {
        setAlertBoundariesLoading(false);
        return;
      }

      const districtFeatures = [];
      for (const district of districtsList) {
        if (!district.gis_id) continue;
        try {
          const res = await getData(gisCoordinatesData + district.gis_id);
          if (res?.length > 0) {
            districtFeatures.push({
              type: "Feature",
              properties: {
                name: district.name || res[0].district,
                gis_id: district.gis_id,
                region_id: district.id,
              },
              geometry: JSON.parse(res[0].coordinates),
            });
          }
        } catch {
        }
      }
      setAlertDistrictGeoJSON(districtFeatures);

      const blockFeatures = [];
      for (const district of districtsList) {
        try {
          const blocks = await postDataWithBody(
            findAllChildrenRegionsById,
            [district.id],
            {}
          );
          if (!blocks || !Array.isArray(blocks)) continue;

          for (const block of blocks) {
            if (!block.gis_id) continue;
            try {
              const blockRes = await getData(
                gisBlockCoordinatesData + block.gis_id
              );
              if (blockRes?.length > 0) {
                blockFeatures.push({
                  type: "Feature",
                  properties: {
                    name: blockRes[0].block || blockRes[0].gpname || block.name,
                    block_code: blockRes[0].block_code,
                    dist_name: district.name || blockRes[0].dist_name || "",
                    gis_id: block.gis_id,
                  },
                  geometry: JSON.parse(blockRes[0].coordinates),
                });
              }
            } catch {
            }
          }
        } catch {
        }
      }
      setAlertBlockGeoJSON(blockFeatures);
      setAlertBoundariesLoaded(true);
    } catch (err) {
      console.error("Failed to load alert boundaries:", err);
    } finally {
      setAlertBoundariesLoading(false);
    }
  }, [stateId, alertBoundariesLoaded, alertBoundariesLoading]);



  const handleDrawPolygon = () => {
  setActiveDrawTool("polygon");
  setClearCircles(true);
  setFacilityCoordinates([]);
  setClickedPoint(null);
  setTimeout(() => {
    setClearCircles(false);
    setDrawPolygon(true);
    setTimeout(() => setDrawPolygon(false), 100);
  }, 150);
};

  const handleClearPolygons = () => {
    setClearPolygons(true);
    setDrawPolygon(false);
    setActiveDrawTool((prev) => (prev === "polygon" ? null : prev));
    setTimeout(() => setClearPolygons(false), 100);
  };

  const handleLocationSelect = (coords) => {
    setCoordinates(coords);
    setClickedPoint({ lat: coords.latitude, lng: coords.longitude, timestamp: Date.now() });
  };
  useEffect(() => {
    if (inciden_mapid) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [inciden_mapid]);

  useEffect(() => {
    if (activeTab === "Search") {
      setSelectAllDistricts(false);
      setActiveDistricts({});
      setSelectedDistrictIds([]);
      setSelectedBlockIds([]);
      setSelectedVillageIds([]);
      setCheckedKeys([]);
      setSearchCoordinates(null);
      setEnabledConditions([]);
      setActiveHeatmapCondition(null);
    } else if (activeTab === "Incident") {
      setSelectAllDistricts(false);
      setActiveDistricts({});
      setSelectedDistrictIds([]);
      setSelectedBlockIds([]);
      setFacilityCoordinates([]);
      setFilteredFacilities([]);
      setSelectedBlockIds([]);
      setSelectedVillageIds([]);
      setSearchCoordinates(null);
      setFacilities((prevFacilities) =>
        prevFacilities.map((facility) => ({ ...facility, selected: false }))
      );
      handleClearCircles();
      handleClearPolygons();
      setCheckedKeys([]);
      setIsKilometerEnabled(false);
      setClickedPoint(null);
      setEnabledConditions([]);
      setActiveHeatmapCondition(null);
      if (selectedIncidentId && storedIncidentData.panchayatIds.length > 0) {
        setSelectedPanchayatIds(storedIncidentData.panchayatIds);
        setIncidentBlockIds(storedIncidentData.blockIds);
        setIncidentMarkerData(storedIncidentData.incidentMarkerData);
        setSupportPointsData(storedIncidentData.supportPoints);
      }
    } else if (activeTab === "Region") {
      setSelectedPanchayatIds([]);
      setFacilityCoordinates([]);
      setFilteredFacilities([]);
      setSupportPointsData([]);
      setIncidentBlockIds([]);
      setFacilities((prevFacilities) =>
        prevFacilities.map((facility) => ({ ...facility, selected: false }))
      );
      handleClearCircles();
      handleClearPolygons();
      setMapData((prev) => ({ ...prev, events: [] }));
      setIsKilometerEnabled(false);
      setClickedPoint(null);
      setIsChecked(false);
      setSelectedIncidentId("");
      setSearchCoordinates(null);
      setEnabledConditions([]);
      setActiveHeatmapCondition(null);
      setStoredIncidentData({
        panchayatIds: [],
        blockIds: [],
        supportPoints: [],
        incidentMarkerData: null,
      });
    } else if (activeTab === "Alerts") {
      setSelectAllDistricts(false);
      setActiveDistricts({});
      setSelectedDistrictIds([]);
      setSelectedBlockIds([]);
      setSelectedVillageIds([]);
      setCheckedKeys([]);
      setSearchCoordinates(null);
      setFacilityCoordinates([]);
      setFilteredFacilities([]);
      setSelectedPanchayatIds([]);
      setSupportPointsData([]);
      setIncidentBlockIds([]);
      setSelectedIncidentId("");
      handleClearCircles();
      handleClearPolygons();
      setClickedPoint(null);
      setIsKilometerEnabled(false);
      setFacilities((prev) => prev.map((f) => ({ ...f, selected: false })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const GOOGLE_WEATHER_API_KEY = "AIzaSyDLzC-FhQmB8JS2H46OW46DNOEboBbrZVg";

  const handleDrawCircle = (radius) => {
  setActiveDrawTool("circle");
  setClearPolygons(true);
  setFacilityCoordinates([]);
  setTimeout(() => {
    setClearPolygons(false);
    setCircleRadius(radius);
    setDrawCircle(true);
    setTimeout(() => setDrawCircle(false), 100);
  }, 150);
};

  const handleClearCircles = () => {
    setClearCircles(true);
    setDrawCircle(false);
    setActiveDrawTool((prev) => (prev === "circle" ? null : prev));
    setTimeout(() => setClearCircles(false), 100);
  };

  const confirmClearIncident = () => {
    setIsChecked(false);
    setSelectedIncidentId("");
    setMapData((prev) => ({ ...prev, events: [] }));
    setSelectedPanchayatIds([]);
    setClickedPoint(null);
    setIncidentBlockIds([]);
    setSupportPointsData([]);
    setStoredIncidentData({ panchayatIds: [], blockIds: [], supportPoints: [], incidentMarkerData: null });
    setShowClearIncidentConfirm(false);
  };

  useEffect(() => {
    if (inciden_mapid && incidentdata.length > 0) {
      const matchingIncident = incidentdata.find((item) => item.value === inciden_mapid);
      if (matchingIncident) {
        setSelectedIncidentId(matchingIncident.value);
        getshowincidata(matchingIncident.value);
        getcensusdata(selectincideregionid);
        getregiondata(matchingIncident.value);
        geteventdata(matchingIncident.value);
        geteventmapdetails(matchingIncident.value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inciden_mapid, incidentdata]);

  const geteventmapdetails = async (id) => {
    try {
      const event_resp = await postDataWithBody(geteventdetails, [id], {});
      if (event_resp && event_resp.length > 0) {
        const eventMarkers = event_resp.map((event) => ({
          id: event.id,
          position: [event.lat, event.lng],
          incidentId: event.incidentId,
          incidentName: event.incidentName,
          status: event.status,
          action: event.action,
          files: event.files,
          createdBy: event.createdBy,
          incidentCategory: event.incidentCategory,
          eventTime: event.eventTime,
          userName: event.userName,
          jobTitle: event.jobTitle,
          mobileNumber: event.mobileNumber,
        }));
        setMapData((prev) => ({ ...prev, events: eventMarkers }));
      }
    } catch (error) {
      console.error("Error fetching event map details:", error);
    }
  };

  const handleSelectChange = (e) => {
    setSelectedType(e.target.value);
  };

  useEffect(() => {
    if (selectedIncidentId) {
      getregiondetails(selectedIncidentId);
      getIncidentMarkerDetails(selectedIncidentId);
    } else {
      setIncidentMarkerData(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIncidentId]);

  // SOP/Resource summary shown under "Linked Modules" — scoped to the whole
  // state until an incident is picked, then scoped to just that incident.
  useEffect(() => {
    const fetchSopInstanceSummary = async () => {
      let url = null;
      if (selectedIncidentId) {
        const incidentSeqId = incidentdata.find((item) => String(item.value) === String(selectedIncidentId))?.incidentSeqId;
        if (!incidentSeqId) return;
        url = getSopInstanceSummaryByIncident.replace("INCIDENTID", incidentSeqId);
      } else {
        if (!stateId) return;
        url = getSopInstanceSummaryByState.replace("STATEID", stateId);
      }
      setSopSummaryLoading(true);
      try {
        const res = await getData(url);
        setSopInstanceSummary(res || null);
      } catch (error) {
        console.error("Error fetching SOP instance summary:", error);
        setSopInstanceSummary(null);
      } finally {
        setSopSummaryLoading(false);
      }
    };
    fetchSopInstanceSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId, selectedIncidentId, incidentdata]);

  const getregiondetails = async (id) => {
    try {
      const ince_region = await postDataWithBody(updateincidentForLadakh, [id], {});
      setSelectedPanchayatIds([]);
      setIncidentBlockIds([]);
      if (ince_region?.regions?.length > 0) {
        const panchayatIds = ince_region.regions
          .map((region) => region.gis_id)
          .filter((gis_id) => gis_id !== null);
        setSelectedPanchayatIds(panchayatIds);
        const blockIds = ince_region.regions
          .map((region) => region.block_gis_id)
          .filter((block_gis_id) => block_gis_id !== null && block_gis_id !== undefined);
        const uniqueBlockIds = [...new Set(blockIds)];
        setIncidentBlockIds(uniqueBlockIds);
        setStoredIncidentData((prev) => ({
          ...prev,
          panchayatIds: panchayatIds,
          blockIds: uniqueBlockIds,
        }));
      }
    } catch (error) {
      setSelectedPanchayatIds([]);
    }
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  useEffect(() => {
    if (!stateId) return;

    window.regionTreeComponent = { showModalPopup, hideModalPopup };
    regionDataMap.set(String(stateId), {
      name: statename,
      id: stateId,
      region_type_id: null,
      gis_id: null,
      level: 0,
    });
    const timer = setTimeout(() => {
      setTreeData([{ title: statename, key: String(stateId), checkable: true }]);
      setExpandedKeys([String(stateId)]);
    }, 100);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId]);

  useEffect(() => {
    if (stateId) {
    fetchDistrictList();
    getFacilityData();
    gerResourceData();
    getinicdentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId]);

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const getIncidentMarkerDetails = async (incidentId) => {
    try {
      const response = await postDataWithBody(updateincidentForLadakh, [incidentId], {});
      if (response) {
        setIncidentMarkerData(response);
        setStoredIncidentData((prev) => ({ ...prev, incidentMarkerData: response }));
        const regions = response.regions;
        const basicinfo = response.basicinfo;
        if (regions?.length > 0 && basicinfo?.length > 0) {
          const districtName = regions[0].name;
          const categoryId = basicinfo[0].category;
          try {
            const supportPointUrl = supportPoints
              .replace("name", districtName)
              .replace("id", categoryId);
            const supportdetails = await getData(supportPointUrl);
            if (supportdetails && Array.isArray(supportdetails)) {
              setSupportPointsData(supportdetails);
              setStoredIncidentData((prev) => ({ ...prev, supportPoints: supportdetails }));
            } else {
              setSupportPointsData([]);
            }
          } catch (spError) {
            console.error("Error fetching support points:", spError);
            setSupportPointsData([]);
          }
        } else {
          setSupportPointsData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching incident marker details:", error);
      setIncidentMarkerData(null);
      setSupportPointsData([]);
    }
  };

  const fetchService = async (searchText) => {
    const name = { name: searchText + "%" };
    setLoading(true);
    try {
      const res = await postDataWithBody(getsearchdetails, name, {});
      const filteredData = res.filter(
        (item) =>
          item.child_id.toLowerCase().includes(searchText.toLowerCase()) ||
          item.parent_first_name.toLowerCase().includes(searchText.toLowerCase())
      );
      setResults(filteredData);
    } catch (err) {
      console.error("API Error:", err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (query.trim().length > 0) {
      const delay = setTimeout(() => fetchService(query), 400);
      return () => clearTimeout(delay);
    } else {
      setResults([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const getshowincidata = async (selectid) => {
    try {
      const res_ponse = await postDataWithBody(getshowbasicdet, [selectid], {});
      if (res_ponse) {
        setbasicindata(res_ponse);
        setSelectedincidentregionid(res_ponse[0].region_ids);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getcensusdata = async (selecenid) => {
    try {
      const cenres = await postDataWithBody(getcensusdatain, [selecenid], {});
      if (cenres) setcensusdata(cenres);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getregiondata = async (selecid) => {
    try {
      const regiondata = await postDataWithBody(getregionincidentdata, [selecid], {});
      if (regiondata) setregiondata(regiondata);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const geteventdata = async (seleceveid) => {
    try {
      const eventdata = await postDataWithBody(geteventincidentdata, [seleceveid], {});
      if (eventdata) seteventdata(eventdata);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getinicdentData = async () => {
    try {
      const incidentdata = await getData(getincidentDatain.replace("STATEID", stateId));
      if (incidentdata) setincidentdata(incidentdata);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const gerResourceData = async () => {
    try {
      const res = await getData(getresourceData.replace("STATEID", stateId));
      if (res) setResourcedata(res);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getFacilityData = async () => {
    const response = await getData(getfacilitydatasearch.replace("STATEID", stateId));
    if (response) {
      const processed = response.map((f) => ({
        ...f,
        latitude: parseFloat(f.latitude),
        longitude: parseFloat(f.longitude),
        selected: false,
      }));
      setFacilities(processed);
    }
  };

  const buildWeatherDropdownOptions = async () => {
    setDropdownLoading(true);
    try {
      const districtsList = await postDataWithBody(findAllChildrenRegionsById, [stateId], {});
      if (!districtsList || !Array.isArray(districtsList)) {
        setWeatherDropdownOptions([]);
        return;
      }

      const options = [];

      for (const district of districtsList) {
        options.push({
          label: district.name,
          value: `district-${district.gis_id}`,
          type: "district",
          gis_id: district.gis_id,
          regionId: district.id,
          districtName: district.name,
        });

        try {
          const blocks = await postDataWithBody(findAllChildrenRegionsById, [district.id], {});
          if (blocks && Array.isArray(blocks)) {
            blocks.forEach((block) => {
              options.push({
                label: block.name,
                value: `block-${block.gis_id}`,
                type: "block",
                gis_id: block.gis_id,
                regionId: block.id,
                districtName: district.name,
              });
            });
          }
        } catch (err) {
          console.error(`Error fetching blocks for district ${district.name}:`, err);
        }
      }

      setWeatherDropdownOptions(options);
    } catch (error) {
      console.error("Error building weather dropdown:", error);
      setWeatherDropdownOptions([]);
    } finally {
      setDropdownLoading(false);
    }
  };

  const fetchWeatherForSingleRegion = async (selectedValue) => {
    if (!selectedValue) {
      setWeatherData([]);
      setWeatherBoundaryGeoJson(null);
      setForecastHourly([]);
      setForecastDaily([]);
      return;
    }

    const selectedOption = weatherDropdownOptions.find((opt) => opt.value === selectedValue);
    if (!selectedOption || !selectedOption.gis_id) {
      setWeatherData([]);
      setWeatherBoundaryGeoJson(null);
      setForecastHourly([]);
      setForecastDaily([]);
      return;
    }

    setWeatherLoading(true);
    try {
      const endpoint =
        selectedOption.type === "district"
          ? gisCoordinatesData + selectedOption.gis_id
          : gisBlockCoordinatesData + selectedOption.gis_id;

      const response = await getData(endpoint);
      if (response && response.length > 0) {
        const geoJson = JSON.parse(response[0].coordinates);
        const regionName =
          selectedOption.type === "block"
            ? `${selectedOption.label} (${selectedOption.districtName})`
            : selectedOption.label;

        setWeatherBoundaryGeoJson({
          geoJson,
          name: regionName,
          type: selectedOption.type,
          gis_id: selectedOption.gis_id,
        });

        const regionDataWithGeoJson = [
          {
            gisId: selectedOption.gis_id,
            geoJson,
            name: regionName,
          },
        ];

        const weatherResults = await fetchWeatherForRegions(regionDataWithGeoJson);
        setWeatherData(weatherResults);
        if (weatherResults && weatherResults.length > 0) {
    const { latitude: lat, longitude: lng } = weatherResults[0];
    if (lat && lng) {
      fetchForecastData(lat, lng);
    }
  }
      } else {
        setWeatherData([]);
        setWeatherBoundaryGeoJson(null);
        setForecastHourly([]);
        setForecastDaily([]);
      }
    } catch (error) {
      console.error("Error fetching weather for region:", error);
      setWeatherData([]);
      setWeatherBoundaryGeoJson(null);
      setForecastHourly([]);
      setForecastDaily([]);
    } finally {
      setWeatherLoading(false);
    }
  };


  const fetchForecastData = async (latitude, longitude) => {
  setForecastLoading(true);
  try {
    const baseParams = `key=${GOOGLE_WEATHER_API_KEY}&location.latitude=${latitude}&location.longitude=${longitude}&languageCode=en&unitsSystem=METRIC`;

    const [hourlyRes, dailyRes] = await Promise.all([
      fetch(
        `https://weather.googleapis.com/v1/forecast/hours:lookup?${baseParams}&hours=24`
      ).then((r) => r.json()),
      fetch(
        `https://weather.googleapis.com/v1/forecast/days:lookup?${baseParams}&days=10`
      ).then((r) => r.json()),
    ]);

    setForecastHourly(hourlyRes?.forecastHours || []);
    setForecastDaily(hourlyRes?.forecastDays
      ? hourlyRes.forecastDays
      : dailyRes?.forecastDays || []);
  } catch (error) {
    console.error("Error fetching forecast data:", error);
    setForecastHourly([]);
    setForecastDaily([]);
  } finally {
    setForecastLoading(false);
  }
};

const fetchPastWeatherData = async (regionId, date) => {
  setWeatherLoading(true);
  try {
    const url = getPastDaysWeatherData
      .replace("REGIONID", regionId)
      .replace("DATE", date);
    const response = await getData(url);

    if (response && Array.isArray(response)) {
      const mapped = response.map((item) => ({
        weatherCondition: item.weatherCondition,
        temperature: item.temperature,
        feelsLikeTemperature: item.feelsLikeTemperature,
        wind: item.wind,
        humidity: { percent: item.relativeHumidity },
        uvIndex: item.uvIndex,
        precipitation: item.precipitation,
        isDaytime: item.isDaytime,
        cloudCover: item.cloudCover,
        displayDateTime: {
          year: item.dataDate?.[0] || item.createdOn?.[0],
          month: item.dataDate?.[1] || item.createdOn?.[1],
          day: item.dataDate?.[2] || item.createdOn?.[2],
          hours: item.createdOn?.[3] || 0,
          minutes: item.createdOn?.[4] || 0,
        },
      }));
      setPastHourlyData(mapped);
    } else {
      setPastHourlyData([]);
    }
  } catch (error) {
    console.error("Error fetching past weather data:", error);
    setPastHourlyData([]);
  } finally {
    setWeatherLoading(false);
  }
};

  const handleWeatherRegionSelect = async (value) => {
  setSelectedWeatherRegion(value);

  setCheckedKeys([]);
  setSelectedRegions([]);
  setSelectedDistrictIds([]);
  setSelectedBlockIds([]);
  setSelectedPanchayatIds([]);
  setSelectedVillageIds([]);

  if (!value) {
    setWeatherData([]);
    setWeatherBoundaryGeoJson(null);
    setForecastHourly([]);
    setForecastDaily([]);
    setPastHourlyData([]);
    setIsPastDate(false);
    return;
  }

  const selectedOption = weatherDropdownOptions.find((opt) => opt.value === value);
  if (!selectedOption || !selectedOption.gis_id) return;

  try {
    const endpoint =
      selectedOption.type === "district"
        ? gisCoordinatesData + selectedOption.gis_id
        : gisBlockCoordinatesData + selectedOption.gis_id;

    const response = await getData(endpoint);
    if (response && response.length > 0) {
      const geoJson = JSON.parse(response[0].coordinates);
      const regionName =
        selectedOption.type === "block"
          ? `${selectedOption.label} (${selectedOption.districtName})`
          : selectedOption.label;

      setWeatherBoundaryGeoJson({
        geoJson,
        name: regionName,
        type: selectedOption.type,
        gis_id: selectedOption.gis_id,
      });
    }
  } catch (error) {
    console.error("Error fetching boundary:", error);
  }

  if (weatherFilterDate) {
    if (isToday(weatherFilterDate)) {
      setIsPastDate(false);
      setPastHourlyData([]);
      fetchWeatherForSingleRegion(value);
    } else {
      setIsPastDate(true);
      setWeatherData([]);
      setForecastHourly([]);
      setForecastDaily([]);
      fetchPastWeatherData(selectedOption.regionId, weatherFilterDate);
    }
  } else {
    setWeatherData([]);
    setForecastHourly([]);
    setForecastDaily([]);
    setPastHourlyData([]);
    setIsPastDate(false);
  }
};


const handleDateChange = (date) => {
  setWeatherFilterDate(date);

  setCheckedKeys([]);
  setSelectedRegions([]);
  setSelectedDistrictIds([]);
  setSelectedBlockIds([]);
  setSelectedPanchayatIds([]);
  setSelectedVillageIds([]);

  if (!selectedWeatherRegion) return;

  if (isToday(date)) {
    setIsPastDate(false);
    setPastHourlyData([]);
    fetchWeatherForSingleRegion(selectedWeatherRegion);
  } else {
    setIsPastDate(true);
    setWeatherData([]);
    setForecastHourly([]);
    setForecastDaily([]);

    const selectedOption = weatherDropdownOptions.find(
      (opt) => opt.value === selectedWeatherRegion
    );
    if (!selectedOption) return;

    fetchPastWeatherData(selectedOption.regionId, date);
  }
};

  useEffect(() => {
    if (stateId) {
    buildWeatherDropdownOptions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateId]);

  useEffect(() => {
  if (
    weatherDropdownOptions.length > 0 &&
    !selectedWeatherRegion &&
    activeTab === "Region"
  ) {
    const firstDistrict = weatherDropdownOptions.find((opt) => opt.type === "district");
    if (firstDistrict) {
      setSelectedWeatherRegion(firstDistrict.value);

      const fetchInitialBoundary = async () => {
        try {
          const endpoint = gisCoordinatesData + firstDistrict.gis_id;
          const response = await getData(endpoint);
          if (response && response.length > 0) {
            const geoJson = JSON.parse(response[0].coordinates);
            setWeatherBoundaryGeoJson({
              geoJson,
              name: firstDistrict.label,
              type: "district",
              gis_id: firstDistrict.gis_id,
            });
          }
        } catch (error) {
          console.error("Error fetching initial boundary:", error);
        }
      };
      fetchInitialBoundary();

      const todayDate = new Date().toISOString().split("T")[0];
      setWeatherFilterDate(todayDate);
      setIsPastDate(false);
      fetchWeatherForSingleRegion(firstDistrict.value);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [weatherDropdownOptions]);

  useEffect(() => {
  if (activeTab !== "Region") {
    setWeatherData([]);
    setWeatherBoundaryGeoJson(null);
    setSelectedWeatherRegion("");
    setWeatherFilterDate(new Date().toISOString().split("T")[0]);
    setForecastHourly([]);
    setForecastDaily([]);
    setPastHourlyData([]);
    setIsPastDate(false);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [activeTab]);

  const hideModalPopup = () => setShowPopup(false);

  const onLoadData = (treeNode) => {
    return new Promise(async (resolve) => {
      const newTreeData = [...treeData];
      let regionList = await generateTreeNodes(treeNode);
      getNewTreeData(newTreeData, treeNode.props.eventKey, regionList, 5);
      setTreeData(newTreeData);
      resolve();
    });
  };

  const generateTreeNodes = async (treeNode) => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const { keySanitized, level } = getHierarchyInfo(key);
    const rgnList = await postDataWithBody(findAllChildrenRegionsById, [keySanitized], {});
    rgnList.forEach(function (region) {
      let keyVal = `${key}-${region.id}`;
      regionDataMap.set(keyVal, {
        name: region.name,
        id: region.id,
        region_type_id: region.region_type_id,
        gis_id: region.gis_id,
        level: level + 1,
      });
      regionDataMap.set(region.id.toString(), {
        name: region.name,
        id: region.id,
        region_type_id: region.region_type_id,
        gis_id: region.gis_id,
        level: level + 1,
      });
      const newLevel = level + 1;
      const willBeLeaf = newLevel >= 2;
      arr.push({
        title: (
          <RegionNode
            regionTypeId={region.region_type_id}
            isLastNode={willBeLeaf}
            keyVal={keyVal}
            selectedId={handleSelectedId}
            id={region.id}
            text={region.name}
            displayNewUI={true}
          />
        ),
        key: keyVal,
        isLeaf: willBeLeaf,
        checkable: true,
      });
    });
    return arr;
  };

  const getHierarchyInfo = (key) => {
    let keySanitized = null;
    let level = 0;
    let isLastNode = false;
    if (key.indexOf("-") > -1) {
      const keyParts = key.split("-");
      level = keyParts.length - 1;
      if (keyParts.length === 5) isLastNode = true;
      keySanitized = keyParts[keyParts.length - 1];
    } else {
      keySanitized = key;
      level = 0;
    }
    return { keySanitized, level, isLastNode };
  };

  const setLeaf = (treeData, curKey, level) => {
    const loopLeaf = (data, lev) => {
      const l = lev - 1;
      data.forEach((item) => {
        if (item.key.length > curKey.length ? item.key.indexOf(curKey) !== 0 : curKey.indexOf(item.key) !== 0) return;
        if (item.children) loopLeaf(item.children, l);
        else if (l < 1) item.isLeaf = true;
      });
    };
    loopLeaf(treeData, level + 1);
  };

  const getNewTreeData = (treeData, curKey, child, level) => {
    const loop = (data) => {
      if (level < 1) return;
      data.forEach((item) => {
        if (curKey.indexOf(item.key) === 0) {
          if (item.children) loop(item.children);
          else item.children = child;
        }
      });
    };
    loop(treeData);
    setLeaf(treeData, curKey, level);
  };

  const getAllChildKeys = (treeData, parentKey) => {
    const childKeys = [];
    const findChildren = (nodes) => {
      nodes.forEach((node) => {
        if (node.key.startsWith(parentKey + "-")) {
          childKeys.push(node.key);
          if (node.children) findChildren(node.children);
        }
      });
    };
    findChildren(treeData);
    return childKeys;
  };

  const handleSelectedId = (idval, type, keyVal, regionTypeId) => {
    showModalPopup(idval, type, keyVal, regionTypeId);
  };

  const showModalPopup = (id, type, keyVal, regionTypeId) => {
    let actionTypeStr = type === "EDIT" ? "Edit Region Information" : "Create Region";
    setRegionTypeId(regionTypeId);
    setShowPopup(true);
    setActionType(type);
    setKeyVal(keyVal);
    setActionTypeHeader(actionTypeStr);
    setId(id);
  };

  const processIndividualNode = async (
    nodeKey, regionData, checkedKeys, regions, districts, blocks, panchayats, villages, isChecking
  ) => {
    if (isChecking) {
      if (regionData.gis_id) {
        switch (regionData.level) {
          case 1: districts.push(regionData.gis_id); break;
          case 2: blocks.push(regionData.gis_id); break;
          case 3: panchayats.push(regionData.gis_id); break;
          case 4: villages.push(regionData.gis_id); break;
          default: break;
        }
      }
      regions.push({
        name: regionData.name,
        gis_id: regionData.gis_id,
        id: regionData.id,
        region_type_id: regionData.region_type_id,
        level: regionData.level,
      });
      if (regionData.level < 4) {
        const allChildKeys = getAllChildKeys(treeData, nodeKey);
        for (const childKey of allChildKeys) {
          if (!checkedKeys.includes(childKey)) {
            checkedKeys.push(childKey);
            const childData = regionDataMap.get(childKey);
            if (childData) {
              regions.push({
                name: childData.name,
                gis_id: childData.gis_id,
                id: childData.id,
                region_type_id: childData.region_type_id,
                level: childData.level,
              });
              if (childData.gis_id) {
                switch (childData.level) {
                  case 1: districts.push(childData.gis_id); break;
                  case 2: blocks.push(childData.gis_id); break;
                  case 3: panchayats.push(childData.gis_id); break;
                  case 4: villages.push(childData.gis_id); break;
                  default: break;
                }
              }
            }
          }
        }
      }
    } else {
      const keysToRemove = [nodeKey, ...getAllChildKeys(treeData, nodeKey)];
      for (const keyToRemove of keysToRemove) {
        const index = checkedKeys.indexOf(keyToRemove);
        if (index > -1) checkedKeys.splice(index, 1);
        const dataToRemove = regionDataMap.get(keyToRemove);
        if (dataToRemove) {
          const regionIndex = regions.findIndex((r) => r.id === dataToRemove.id);
          if (regionIndex > -1) regions.splice(regionIndex, 1);
          if (dataToRemove.gis_id) {
            switch (dataToRemove.level) {
              case 1: removeFromArray(districts, dataToRemove.gis_id); break;
              case 2: removeFromArray(blocks, dataToRemove.gis_id); break;
              case 3: removeFromArray(panchayats, dataToRemove.gis_id); break;
              case 4: removeFromArray(villages, dataToRemove.gis_id); break;
              default: break;
            }
          }
        }
      }
    }
  };

  const removeFromArray = (array, item) => {
    const index = array.indexOf(item);
    if (index > -1) array.splice(index, 1);
  };

  const toggleFacilitySelect = (facilityId) => {
    setFacilities((prevFacilities) =>
      prevFacilities.map((facility) =>
        facility.id === facilityId ? { ...facility, selected: !facility.selected } : facility
      )
    );
  };

  const toggleSelectAllFacilities = () => {
    const allSelected = facilities.every((f) => f.selected);
    setFacilities((prevFacilities) =>
      prevFacilities.map((facility) => ({ ...facility, selected: !allSelected }))
    );
  };

  const fetchFacilityData = async (selectedIds) => {
    try {
      const validIds = selectedIds.filter((id) => id !== undefined && id !== null && id !== "");
      const response = await postDataWithBody(getfacilitytabledata, validIds, {});
      if (response) setFacilityData(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFacilitySearch = async () => {
    if (!isKilometerEnabled) {
      toast.error("Please enable the Kilometer Range checkbox first", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }
    if (!coordinates.latitude || !coordinates.longitude) {
      toast.error("Please select a location on the map first by clicking on it", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }
    try {
      // Compute matches from the already-loaded facility list (same records the
      // "All Facilities" checklist and map markers use, with confirmed-correct
      // latitude/longitude) instead of trusting the distance API's field shape,
      // which was returning a response the UI couldn't parse (silent "no results").
      const matches = facilities.filter((facility) => {
        const lat = parseFloat(facility.latitude);
        const lng = parseFloat(facility.longitude);
        if (isNaN(lat) || isNaN(lng)) return false;
        return calculateDistance(coordinates.latitude, coordinates.longitude, lat, lng) <= kilometerRange;
      });

      // Drive the map/checklist display from the search result: only matched
      // facilities stay checked/visible, everything else is cleared out.
      setFacilities((prevFacilities) =>
        prevFacilities.map((facility) => ({
          ...facility,
          selected: matches.some((m) => m.id === facility.id),
        }))
      );

      if (matches.length === 0) {
        setFacilityCoordinates([]);
        toast.info("No facilities found in this range");
        return [];
      }

      const facilityCoords = matches.map((facility) => ({
        id: facility.id?.toString(),
        position: [parseFloat(facility.latitude), parseFloat(facility.longitude)],
        name: facility.text || `Facility ${facility.id}`,
        address: facility.address || "Address not available",
        text: facility.text || `Facility ${facility.id}`,
        value: facility.value || "DEFAULT",
      }));
      return facilityCoords;
    } catch (error) {
      console.error("Error searching facilities:", error);
      return [];
    }
  };

  const searhdisresource = async () => {
    const missing = [];
    if (!isKilometerEnabled) missing.push("enable the Kilometer Range checkbox");
    if (!coordinates.latitude || !coordinates.longitude) missing.push("click on the map to select a location");
    if (!selectedType) missing.push("select a resource from the dropdown");
    if (missing.length > 0) {
      toast.error(`Please ${missing.join(", ")} before searching resources.`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    try {
      const comparefacility = await handleFacilitySearch();
      const req = {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
        distance: kilometerRange * 1000,
        resourceactivity: selectedType,
      };
      const resourceResponse = await postDataWithBody(resourcedistance, req, {});
      const resourceIds = Array.isArray(resourceResponse)
        ? resourceResponse.map((id) => String(id)).filter(Boolean)
        : [];
      const facilityCoords = Array.isArray(comparefacility)
        ? comparefacility
            .filter((facility) => {
              const facilityId = facility?.id?.toString();
              return facilityId && resourceIds.includes(facilityId) && !facility.is_deleted;
            })
            .map((facility) => ({
              id: facility.id?.toString(),
              position: facility.position || [0, 0],
              name: facility.facility_name || `Facility ${facility.id}`,
              address: facility.facility_address || "Address not available",
              text: facility.text || facility.name,
              value: facility.value || "DEFAULT",
            }))
        : [];
      if (facilityCoords.length > 0) {
        setFacilityCoordinates(facilityCoords);
      } else {
        setFacilityCoordinates([]);
        toast.info("No matching facilities found.");
      }
      return facilityCoords;
    } catch (error) {
      console.error("Error in searchdisresource:", error);
      return [];
    }
  };

  const clearFacilitySelections = () => {
    setFacilities((prevFacilities) =>
      prevFacilities.map((facility) => ({ ...facility, selected: false }))
    );
    setFacilitySearchTerm("");
    setFacilityCoordinates([]);
    setSelectedPoint(null);
    setClickedPoint(null);
    setIsKilometerEnabled(false);
  };

  const [stateGeoJSON, setStateGeoJSON] = useState([]);
  const [activeDistricts, setActiveDistricts] = useState({});
  const [selectAllDistricts, setSelectAllDistricts] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [coordinates, setCoordinates] = useState({ latitude: null, longitude: null });
  const [selectedPoint, setSelectedPoint] = useState(null);

  useEffect(() => {
    getUserProfile();
    fetchGisData();
    fetchDistrictList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectAllState) {
      mapStateCoordinates();
    } else {
      setStateGeoJSON([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAllState]);

  useEffect(() => {
    if (mapData.branches.length > 0) {
      const uniqueDistricts = [...new Set(mapData.branches.map((branch) => branch.district))];
      setDistricts(uniqueDistricts);
    }
  }, [mapData.branches]);

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const fetchGisData = async () => {
    try {
      const response = await getData(getGisData);
      if (response) processResponseData(response);
    } catch (error) {
      console.error("Error fetching GIS data:", error);
    }
  };

  const processResponseData = (data) => {
    if (!data.branches_list || !data.atms_list || !data.incidents_list) return;
    const branches = data.branches_list.map((branch) => ({
      id: branch.id,
      name: branch.branchName,
      position: [parseFloat(branch.latitude) || 25.59, parseFloat(branch.longitude) || 85.13],
      manager:
        branch.branch_contact?.length > 0
          ? `${branch.branch_contact[0].firstName} ${branch.branch_contact[0].lastName}`
          : "N/A",
      phones: branch.phoneNumber || "N/A",
      email: branch.email || "N/A",
      address: `${branch.addressLine1} ${branch.addressLine2 || ""}`,
      district: branch.district || "N/A",
      ifscCode: branch.ifscCode || "N/A",
      originalData: branch,
    }));
    const atms = data.atms_list.map((atm) => ({
      id: atm.id,
      name: atm.name,
      position: [parseFloat(atm.latitude) || 25.59, parseFloat(atm.longitude) || 85.13],
      status: atm.activeStatus ? "Working" : "Inactive",
      code: atm.code || "N/A",
      address: atm.addressLine || "N/A",
      district: atm.district || "N/A",
      originalData: atm,
    }));
    const incidents = data.incidents_list.map((incident) => {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
      };
      return {
        id: incident.id,
        type: incident.incidentName,
        position: [parseFloat(incident.latitude) || 25.59, parseFloat(incident.longitude) || 85.13],
        severity: incident.severityLevel || "Medium",
        date: formatDate(incident.incidentDateAndTime),
        reporter: incident.reporterName,
        status: incident.event_status,
        description: incident.description,
        affectedServices: incident.affectedServices,
        originalData: incident,
      };
    });
    setMapData({ branches, atms, incidents });
  };

  const mapStateCoordinates = async () => {
    if (!stateId) return;
    try {
      const res = await getData(gisStateCoordinates + stateId);
      if (res && res.length > 0) {
        const stateData = res[0];
        let coordinates;
        try {
          coordinates = JSON.parse(stateData.coordinates);
        } catch (e) {
          return;
        }
        const geoJsonData = {
          type: "Feature",
          properties: { name: stateData.state_name, state_id: stateData.state_id },
          geometry: coordinates,
        };
        setStateGeoJSON(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
    }
  };

  const fetchDistrictList = async () => {
    if (!stateId) return;
    try {
      const response = await getData(ladakhDistrictsInGis + stateId);
      if (response && Array.isArray(response)) {
        const sortedDistricts = response.sort((a, b) => a.value.localeCompare(b.value));
        setDistrictList(sortedDistricts);
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const onSelect = (info) => console.log("selected", info);

  const handleSearchResultSelect = async (item) => {
    try {
      const response = await postDataWithBody(searchshowlatdetails, { name: item.child_id }, {});
      if (response && response.length > 0) {
        const coordinates = JSON.parse(response[0].coordinates);
        if (coordinates.coordinates && coordinates.coordinates.length > 0) {
          const geoJsonData = JSON.parse(response[0].coordinates);
          setSearchCoordinates(geoJsonData);
          setQuery(item.child_id + " , " + item.parent_first_name);
          setResults([]);
        }
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Failed to get coordinates for the selected location");
    }
  };

  const onCheck = async (checkedKeys, info) => {
    setIsLoading(true);
  setWeatherData([]);
  setWeatherBoundaryGeoJson(null);
  setForecastHourly([]);
  setForecastDaily([]);
  setPastHourlyData([]);
  setIsPastDate(false);
  setSelectedWeatherRegion("");
  setWeatherFilterDate(new Date().toISOString().split("T")[0]);
    const node = info.node;
    const nodeKey = node.key;
    const regionData = regionDataMap.get(nodeKey);
    const currentCheckedKeys = Array.isArray(checkedKeys) ? checkedKeys : checkedKeys.checked || [];
    let newCheckedKeys = [...currentCheckedKeys];
    let newSelectedRegions = [...selectedRegions];
    let newSelectedDistrictIds = [...selectedDistrictIds];
    let newSelectedBlockIds = [...selectedBlockIds];
    let newSelectedPanchayatIds = [...selectedPanchayatIds];
    let newSelectedVillageIds = [...selectedVillageIds];

    try {
      if (regionData) {
        if (info.checked) {
          if (!currentCheckedKeys.includes(nodeKey)) newCheckedKeys.push(nodeKey);
          if (nodeKey === String(stateId)) {
            if (!treeData.find((item) => item.key === String(stateId))?.children) {
              const biharChildren = await generateTreeNodes({ props: { eventKey: String(stateId) } });
              const newTreeData = [...treeData];
              getNewTreeData(newTreeData, String(stateId), biharChildren, 5);
              setTreeData(newTreeData);
              const allDistrictKeys = biharChildren.map((child) => child.key);
              newCheckedKeys = [...new Set([...newCheckedKeys, ...allDistrictKeys])];
              const allDistrictGisIds = [];
              biharChildren.forEach((child) => {
                const childData = regionDataMap.get(child.key);
                if (childData?.gis_id) {
                  allDistrictGisIds.push(childData.gis_id);
                  newSelectedRegions.push({
                    name: childData.name,
                    gis_id: childData.gis_id,
                    id: childData.id,
                    region_type_id: childData.region_type_id,
                    level: childData.level,
                  });
                }
              });
              newSelectedDistrictIds = [...new Set([...newSelectedDistrictIds, ...allDistrictGisIds])];
            } else {
              const biharChildren = treeData.find((item) => item.key === String(stateId))?.children || [];
              const allDistrictKeys = biharChildren.map((child) => child.key);
              newCheckedKeys = [...new Set([...newCheckedKeys, ...allDistrictKeys])];
              const allDistrictGisIds = [];
              biharChildren.forEach((child) => {
                const childData = regionDataMap.get(child.key);
                if (childData?.gis_id) {
                  allDistrictGisIds.push(childData.gis_id);
                  newSelectedRegions.push({
                    name: childData.name,
                    gis_id: childData.gis_id,
                    id: childData.id,
                    region_type_id: childData.region_type_id,
                    level: childData.level,
                  });
                }
              });
              newSelectedDistrictIds = [...new Set([...newSelectedDistrictIds, ...allDistrictGisIds])];
            }
          } else {
            await processIndividualNode(
              nodeKey, regionData, newCheckedKeys, newSelectedRegions,
              newSelectedDistrictIds, newSelectedBlockIds, newSelectedPanchayatIds, newSelectedVillageIds, true
            );
            if (regionData.level === 1) {
              const biharChildren = treeData.find((item) => item.key === String(stateId))?.children || [];
              const allDistrictKeys = biharChildren.map((child) => child.key);
              const allDistrictsSelected =
                allDistrictKeys.length > 0 && allDistrictKeys.every((districtKey) => newCheckedKeys.includes(districtKey));
              if (allDistrictsSelected && !newCheckedKeys.includes(String(stateId))) newCheckedKeys.push(String(stateId));
            }
          }
        } else {
          if (nodeKey === String(stateId)) {
            const getAllDescendantKeys = (nodes, parentKey) => {
              const descendants = [];
              const processNodes = (nodeList) => {
                nodeList.forEach((node) => {
                  if (node.key.startsWith(parentKey + "-") || node.key === parentKey) {
                    descendants.push(node.key);
                    if (node.children) processNodes(node.children);
                  }
                });
              };
              processNodes(nodes);
              return descendants;
            };
            const biharDescendants = getAllDescendantKeys(treeData, String(stateId));
            newCheckedKeys = newCheckedKeys.filter((key) => !biharDescendants.includes(key) && key !== String(stateId));
            newSelectedRegions = [];
            newSelectedDistrictIds = [];
            newSelectedBlockIds = [];
            newSelectedPanchayatIds = [];
            newSelectedVillageIds = [];
          } else {
            await processIndividualNode(
              nodeKey, regionData, newCheckedKeys, newSelectedRegions,
              newSelectedDistrictIds, newSelectedBlockIds, newSelectedPanchayatIds, newSelectedVillageIds, false
            );
            if (regionData.level === 1 && newCheckedKeys.includes(String(stateId))) {
              newCheckedKeys = newCheckedKeys.filter((key) => key !== String(stateId));
            }
          }
        }
      }
      setCheckedKeys(newCheckedKeys);
      setSelectedRegions(newSelectedRegions);
      setSelectedDistrictIds(newSelectedDistrictIds);
      setSelectedBlockIds(newSelectedBlockIds);
      setSelectedPanchayatIds(newSelectedPanchayatIds);
      setSelectedVillageIds(newSelectedVillageIds);
      setDistrictId(regionData?.gis_id || "");
    } finally {
      setIsLoading(false);
    }
  };

  const selectedFacilities = facilities.filter((f) => f.selected).map((f) => f.id);

  const handleDrawCreated = (e) => {};
  const handleDrawDeleted = (e) => {};

  const clearSearch = () => {
    setQuery("");
    setResults([]);
    setSearchCoordinates(null);
  };

  // ─── THEME-AWARE STYLE TOKENS ─────────────────────────────────────────
  const isDark = theme !== "light";
  const tokens = {
    panelBg: isDark ? "#131c2e" : "#f4f7fb",
    cardBg: isDark ? "#1a2540" : "#ffffff",
    cardBorder: isDark ? "1px solid rgba(74,95,122,0.35)" : "1px solid rgba(46,109,164,0.1)",
    headerBg: isDark
      ? "linear-gradient(135deg, #0f1a2e 0%, #162040 100%)"
      : "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
    sectionHeaderBg: isDark
      ? "linear-gradient(135deg, #162040, #1a2a50)"
      : "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
    sectionBodyBg: isDark ? "#1a2540" : "#f8fafd",
    textPrimary: isDark ? "#e2e8f0" : "#1a2a3a",
    textSecondary: isDark ? "#8899aa" : "#5a6a7a",
    textMuted: isDark ? "#556677" : "#8899aa",
    inputBg: isDark ? "#0f1a2e" : "#ffffff",
    inputBorder: isDark ? "#2a3f5f" : "#d0dce8",
    accentColor: isDark ? "#2a7de1" : "#2E6DA4",
    accentLight: isDark ? "rgba(42,125,225,0.15)" : "rgba(46,109,164,0.08)",
    tabActiveBg: isDark ? "#2a7de1" : "#2E6DA4",
    tabActiveText: "#ffffff",
    tabInactiveBg: "transparent",
    tabInactiveText: isDark ? "#8899aa" : "#5a6a7a",
    btnPrimary: isDark
      ? "linear-gradient(135deg, #2a7de1, #1a5fb0)"
      : "linear-gradient(120deg, #2E6DA4, #3B82C4)",
    btnSecondary: isDark
      ? "rgba(255,255,255,0.06)"
      : "rgba(46,109,164,0.06)",
    shadow: isDark
      ? "0 4px 24px rgba(0,0,0,0.4)"
      : "0 4px 24px rgba(46,109,164,0.08)",
    divider: isDark ? "rgba(74,95,122,0.25)" : "rgba(46,109,164,0.08)",
  };

  // ─── RENDER ────────────────────────────────────────────────────────────

  return (
    <FullScreen handle={handle} className="gis-map-view">
      {/* ─── Global style injection ─── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');
        .gis-map-view { font-family: 'Poppins', 'Segoe UI', sans-serif; }
        .gis-scroll::-webkit-scrollbar { width: 4px; }
        .gis-scroll::-webkit-scrollbar-track { background: transparent; }
        .gis-scroll::-webkit-scrollbar-thumb { background: ${isDark ? '#2a3f5f' : '#c0cfe0'}; border-radius: 10px; }
        .gis-scroll::-webkit-scrollbar-thumb:hover { background: ${isDark ? '#3a5070' : '#95b0d0'}; }

        .gis-card {
          border-radius: 12px;
          overflow: hidden;
          background: ${tokens.cardBg};
          border: ${tokens.cardBorder};
          box-shadow: 0 1px 4px ${isDark ? 'rgba(0,0,0,0.3)' : 'rgba(30,58,95,0.06)'};
          margin-bottom: 12px;
          transition: box-shadow 0.2s ease;
        }
        .gis-card:hover { box-shadow: 0 4px 16px ${isDark ? 'rgba(0,0,0,0.45)' : 'rgba(30,58,95,0.1)'}; }

        .gis-card-header {
          background: ${tokens.sectionHeaderBg};
          color: white;
          padding: 10px 14px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          font-size: 12.5px;
          letter-spacing: 0.03em;
          user-select: none;
          transition: filter 0.15s;
        }
        .gis-card-header:hover { filter: brightness(1.1); }

        .gis-card-body { padding: 12px 14px; background: ${tokens.sectionBodyBg}; }

        .gis-btn {
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-size: 11.5px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          letter-spacing: 0.03em;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }
        .gis-btn-fill {
          background: ${tokens.btnPrimary};
          color: white;
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-size: 11.5px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          letter-spacing: 0.03em;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          box-shadow: 0 2px 8px rgba(26,63,111,0.18);
        }
        .gis-btn-fill:hover { filter: brightness(1.1); transform: translateY(-1px); box-shadow: 0 4px 14px rgba(26,63,111,0.25); }
        .gis-btn-outline {
          background: transparent;
          color: ${tokens.textSecondary};
          border: 1.5px solid ${tokens.inputBorder};
          border-radius: 8px;
          padding: 8px 16px;
          font-size: 11.5px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }
        .gis-btn-outline:hover { background: ${tokens.accentLight}; color: ${tokens.accentColor}; border-color: ${tokens.accentColor}; }

        .gis-input {
          width: 100%;
          padding: 8px 12px;
          border: 1.5px solid ${tokens.inputBorder};
          border-radius: 8px;
          font-size: 12px;
          background-color: ${tokens.inputBg};
          color: ${tokens.textPrimary};
          transition: border-color 0.2s, box-shadow 0.2s;
          box-sizing: border-box;
          outline: none;
        }
        .gis-input:focus { border-color: ${tokens.accentColor}; box-shadow: 0 0 0 3px ${tokens.accentLight}; }
        .gis-select {
          width: 100%;
          padding: 8px 12px;
          border: 1.5px solid ${tokens.inputBorder};
          border-radius: 8px;
          font-size: 12px;
          background-color: ${tokens.inputBg};
          color: ${tokens.textPrimary};
          cursor: pointer;
          outline: none;
          transition: border-color 0.2s;
        }
        .gis-select:focus { border-color: ${tokens.accentColor}; box-shadow: 0 0 0 3px ${tokens.accentLight}; }

        .gis-label {
          display: block;
          font-size: 10.5px;
          font-weight: 700;
          color: ${tokens.textMuted};
          margin-bottom: 5px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        .gis-tool-icon {
          width: 38px; height: 38px;
          border-radius: 10px;
          border: 1.5px solid ${tokens.inputBorder};
          background: ${tokens.cardBg};
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: all 0.15s ease;
        }
        .gis-tool-icon:hover { background: ${tokens.accentLight}; border-color: ${tokens.accentColor}; transform: scale(1.06); }
        .gis-tool-icon:active { transform: scale(0.95); }

        .gis-facility-row {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 5px 8px;
          border-radius: 6px;
          cursor: pointer;
          transition: background 0.12s;
          font-size: 12px;
        }
        .gis-facility-row:hover { background: ${tokens.accentLight}; }

        @keyframes gis-spin { to { transform: rotate(360deg); } }
        @keyframes gis-pulse { 0%,100%{opacity:1} 50%{opacity:.5} }
      `}</style>

      {/* ─── Top Header ─── */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 14px",
          background: tokens.headerBg,
          borderRadius: "10px",
          marginBottom: "14px",
          position: "relative",
          boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <div style={{
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    background: "rgba(255,255,255,.16)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }}>
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="white" opacity="0.3"/>
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 2c2.76 0 5 2.24 5 5 0 3.53-4.13 8.78-5 9.88C11.13 17.78 7 12.53 7 9c0-2.76 2.24-5 5-5z" fill="white"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
    </svg>
  </div>
  <div>
    <h1 style={{ margin: 0, fontSize: "14px", fontWeight: "800", color: "#ffffff", letterSpacing: "0.2px" }}>
      GIS Data Management
    </h1>
    <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.75)", marginTop: "1px" }}>
      Manage regions, incidents and disaster alerts on the map
    </div>
  </div>
</div>
        <div style={{ marginLeft: "50px", position: "relative" }}>
          <div style={{ position: "relative" }}>
            <Search size={14} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#8899aa", pointerEvents: "none" }} />
            <input
              type="text"
              placeholder="Search locations..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{
                padding: "8px 34px 8px 34px",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.15)",
                backgroundColor: "rgba(255,255,255,0.95)",
                color: "#1a2a3a",
                outline: "none",
                fontSize: "13px",
                width: "360px",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
              }}
            />
            {query && (
              <button
                onClick={clearSearch}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(0,0,0,0.08)",
                  border: "none",
                  color: "#666",
                  cursor: "pointer",
                  fontSize: "12px",
                  padding: "0",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.15s",
                }}
              >
                ✕
              </button>
            )}
          </div>
          {query && results.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "42px",
                left: 0,
                backgroundColor: tokens.cardBg,
                border: tokens.cardBorder,
                borderRadius: "10px",
                width: "340px",
                maxHeight: "220px",
                overflowY: "auto",
                zIndex: 1000,
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              }}
            >
              {results.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: "10px 14px",
                    borderBottom: `1px solid ${tokens.divider}`,
                    cursor: "pointer",
                    color: tokens.textPrimary,
                    fontSize: "12px",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = tokens.accentLight}
                  onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                  onClick={() => {
                    setQuery(item.child_id);
                    setResults([]);
                    handleSearchResultSelect(item);
                  }}
                >
                  <span style={{ fontWeight: "600" }}>{item.child_id}</span>
                  <span style={{ color: tokens.textMuted, marginLeft: "6px" }}>{item.parent_first_name}</span>
                </div>
              ))}
            </div>
          )}
          {loading && (
            <div style={{ position: "absolute", top: "10px", right: "36px", fontSize: "12px", color: "#8899aa" }}>
              <span style={{ display: "inline-block", animation: "spin 1s linear infinite", width: 14, height: 14, border: "2px solid #ccc", borderTopColor: tokens.accentColor, borderRadius: "50%" }} />
            </div>
          )}
        </div>

        <button
          onClick={captureScreen}
          disabled={capturingScreenshot}
          title="Capture this screen as an image"
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 14px",
            borderRadius: "10px",
            border: "1px solid rgba(255,255,255,0.25)",
            backgroundColor: "rgba(255,255,255,0.14)",
            color: "#ffffff",
            fontSize: "12.5px",
            fontWeight: 700,
            cursor: capturingScreenshot ? "not-allowed" : "pointer",
            opacity: capturingScreenshot ? 0.7 : 1,
            transition: "background 0.15s ease",
            flexShrink: 0,
          }}
          onMouseEnter={(e) => { if (!capturingScreenshot) e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.24)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.14)"; }}
        >
          {capturingScreenshot ? (
            <span style={{ display: "inline-block", animation: "spin 1s linear infinite", width: 14, height: 14, border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff", borderRadius: "50%" }} />
          ) : (
            <Camera size={14} />
          )}
          {capturingScreenshot ? "Capturing..." : "Capture"}
        </button>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      <div style={{ display: "flex", height: "100vh", fontFamily: "'Segoe UI', -apple-system, sans-serif" }}>
        {/* Map Section */}
        <div style={{ flex: 3 }}>
          {activeTab === "Alerts" ? (
    <DashboardMap height="100vh" gisMap={true}/>
  ) : (
          <RMMap
            stateId={stateId}
            selectedRegions={selectedRegions}
            selectedDistrictIds={selectedDistrictIds}
            selectedBmskids={[]}
            selectedBlockIds={selectedBlockIds}
            incidentBlockIds={incidentBlockIds}
            selectedPanchayatIds={selectedPanchayatIds}
            selectedVillageIds={selectedVillageIds}
            selectedDistrictId={districtId}
            isLoading={isLoading}
            selectedFacilities={facilities.filter((f) => f.selected)}
            mapData1={mapData}
            onLocationSelect={handleLocationSelect}
            drawCircle={drawCircle}
            circleRadius={circleRadius}
            clearCircles={clearCircles}
            facilityCoordinates={facilityCoordinates}
            bmskdetails={[]}
            drawPolygon={drawPolygon}
            clearPolygons={clearPolygons}
            filteredFacilities2={filteredFacilities}
            handleDrawCreated={handleDrawCreated}
            handleDrawDeleted={handleDrawDeleted}
            clickedPoint={clickedPoint}
            setClickedPoint={setClickedPoint}
            bmskActiveDistricts={{}}
            isBmskMode={false}
            isKilometerEnabled={isKilometerEnabled}
            searchCoordinates={searchCoordinates}
            incidentMarkerData={incidentMarkerData}
            selectedIncidentDetails={incidentdata.find((item) => String(item.value) === String(selectedIncidentId)) || null}
            supportPointsData={supportPointsData}
            weatherData={weatherData}
            weatherBoundaryGeoJson={weatherBoundaryGeoJson}
            activeTab={activeTab}
            heatmapGridData={heatmapGridData}
            activeHeatmapCondition={activeHeatmapCondition}
            heatmapLoading={heatmapLoading}
            alertDistrictGeoJSON={alertDistrictGeoJSON}
            alertBlockGeoJSON={alertBlockGeoJSON}
            alertBoundariesLoading={alertBoundariesLoading}
            isAlertsTab={activeTab === "Alerts"}
          />
  )}
        </div>

        {/* ═══════════════════════════════════════════════════════
             RIGHT PANEL — Redesigned
        ═══════════════════════════════════════════════════════ */}
        <div
          style={{
            flex: 1,
            backgroundColor: tokens.panelBg,
            borderLeft: `1px solid ${tokens.divider}`,
            boxSizing: "border-box",
            overflow: "hidden",
            minWidth: "340px",
            maxWidth: "380px",
            borderRadius: "14px",
            marginLeft: "6px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* ─── Segmented Tab Bar ─── */}
          <div style={{
            padding: "10px 12px 8px",
            flexShrink: 0,
            background: isDark ? tokens.panelBg : tokens.panelBg,
          }}>
            <div style={{
              display: "flex",
              gap: "4px",
              padding: "3px",
              background: isDark ? "rgba(15,26,46,0.7)" : "rgba(30,58,95,0.06)",
              borderRadius: "10px",
            }}>
              {[
                { id: "Region",   icon: <MapPin size={12} />,         label: "Region" },
                { id: "Search",   icon: <Search size={12} />,         label: "Search" },
                { id: "Incident", icon: <AlertTriangle size={12} />,  label: "Incident" },
                { id: "Alerts",   icon: <Cloud size={12} />,          label: "Alerts" },
              ].map((tab) => {
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    style={{
                      flex: 1,
                      padding: "8px 4px",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "11.5px",
                      fontWeight: isActive ? "700" : "500",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                      whiteSpace: "nowrap",
                      transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
                      background: isActive
                        ? (isDark ? tokens.accentColor : "#ffffff")
                        : "transparent",
                      color: isActive
                        ? (isDark ? "#fff" : "#2E6DA4")
                        : tokens.tabInactiveText,
                      boxShadow: isActive
                        ? (isDark ? "0 2px 8px rgba(42,125,225,0.3)" : "0 2px 8px rgba(46,109,164,0.15)")
                        : "none",
                    }}
                  >
                    {tab.icon}
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* ─── Scrollable Content ─── */}
          <div className="gis-scroll" style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: "0 12px 14px" }}>

          {/* ═══════════════════════════════════════════════════
              REGION TAB
          ═══════════════════════════════════════════════════ */}
          {activeTab === "Region" && (
            <>
              {/* Region Hierarchy Card */}
              <div className="gis-card">
                <div className="gis-card-header" onClick={() => setShowRegionHierarchy(!showRegionHierarchy)}>
                  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                    <MapPin size={13} /> Region Hierarchy
                  </span>
                  {showRegionHierarchy ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                </div>
                {showRegionHierarchy && (
                  <div className="gis-card-body">
                    <Tree
                      onSelect={onSelect}
                      onCheck={onCheck}
                      loadData={(node) => onLoadData(node, { level: 5 })}
                      treeData={treeData}
                      checkable={true}
                      expandedKeys={expandedKeys}
                      onExpand={setExpandedKeys}
                      checkedKeys={checkedKeys}
                      checkStrictly={true}
                      showLine={true}
                      style={{ color: tokens.textPrimary }}
                    />
                  </div>
                )}
              </div>

              {/* Weather Panel */}
              <WeatherPanel
                weatherData={weatherData}
                isLoading={weatherLoading}
                theme={theme}
                dropdownOptions={weatherDropdownOptions}
                selectedWeatherRegion={selectedWeatherRegion}
                onRegionSelect={handleWeatherRegionSelect}
                weatherFilterDate={weatherFilterDate}
                onDateChange={handleDateChange}
                dropdownLoading={dropdownLoading}
                forecastHourly={forecastHourly}
                forecastDaily={forecastDaily}
                forecastLoading={forecastLoading}
                isPastDate={isPastDate}
                pastHourlyData={pastHourlyData}
              />
            </>
          )}

          {/* ═══════════════════════════════════════════════════
              SEARCH TAB
          ═══════════════════════════════════════════════════ */}
          {activeTab === "Search" && (
            <>
              {/* ── Map Tools Card: Draw + Clear ── */}
              <div className="gis-card">
                <div style={{
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                  <span className="gis-label" style={{ margin: 0 }}>Drawing Tools</span>
                  <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <div className="gis-tool-icon" onClick={() => handleDrawCircle(500)} title="Draw Circle">
                      <img src={logo} alt="Circle" width={28} height={28} style={{ filter: "brightness(0)" }} />
                    </div>
                    <div className="gis-tool-icon" onClick={() => handleDrawPolygon()} title="Draw Polygon">
                      <img src={logo1} alt="Polygon" width={28} height={28} style={{ filter: "brightness(0)" }} />
                    </div>
                    <button
                      className="gis-btn-outline"
                      style={{ padding: "6px 14px", fontSize: "11px" }}
                      onClick={() => { handleClearCircles(); handleClearPolygons(); setClickedPoint(null); }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
                {activeDrawTool && (
                  <div style={{
                    margin: "0 14px 10px", padding: "8px 10px", borderRadius: "8px",
                    background: tokens.accentLight, color: tokens.accentColor,
                    fontSize: "11px", lineHeight: 1.4, display: "flex", alignItems: "flex-start", gap: "6px",
                  }}>
                    <span style={{ flexShrink: 0 }}>ℹ️</span>
                    <span style={{ flex: 1 }}>
                      {activeDrawTool === "circle"
                        ? "Click on the map to set circle center"
                        : "Click points on the map to draw a polygon, then double-click to finish"}
                    </span>
                    <span onClick={() => setActiveDrawTool(null)} style={{ cursor: "pointer", flexShrink: 0, opacity: 0.7 }}>✕</span>
                  </div>
                )}
              </div>

              {/* ── Facility Hierarchy Card ── */}
              <div className="gis-card">
                <div className="gis-card-header" onClick={() => setShowfacilityHierarchy(!showfacilityHierarchy)}>
                  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                    ⚡ Facilities
                  </span>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{
                      fontSize: "10px",
                      background: "rgba(255,255,255,0.2)",
                      padding: "2px 8px",
                      borderRadius: "10px",
                    }}>
                      {facilities.filter(f => f.selected).length}/{facilities.length}
                    </span>
                    {showfacilityHierarchy ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                  </div>
                </div>
                {showfacilityHierarchy && (
                  <div className="gis-card-body" style={{ padding: "10px 12px" }}>
                    {/* Search + Table icon */}
                    <div style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>
                      <input type="text" placeholder="Search facility..." value={facilitySearchTerm}
                        className="gis-input"
                        onChange={(e) => setFacilitySearchTerm(e.target.value)}
                        style={{ flex: 1, fontSize: "11.5px" }} />
                      <div
                        style={{
                          cursor: selectedFacilities.length > 0 ? "pointer" : "not-allowed",
                          opacity: selectedFacilities.length > 0 ? 1 : 0.3,
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={async () => { if (selectedFacilities.length > 0) { await fetchFacilityData(selectedFacilities); setshowmodel(true); } }}>
                        <img src={myImage} alt="table" width={24} height={24} />
                      </div>
                    </div>

                    {/* Select All */}
                    <div className="gis-facility-row" onClick={toggleSelectAllFacilities}
                      style={{ marginBottom: "4px", paddingBottom: "6px", borderBottom: `1px solid ${tokens.divider}` }}>
                      <input type="checkbox" checked={facilities.every((f) => f.selected)} onChange={toggleSelectAllFacilities}
                        style={{ width: "14px", height: "14px", cursor: "pointer", accentColor: tokens.accentColor }} />
                      <span style={{ fontSize: "12px", fontWeight: "700", color: "#b8860b" }}>All Facilities</span>
                    </div>

                    {/* Facility List */}
                    <div className="gis-scroll" style={{ maxHeight: "180px", overflowY: "auto" }}>
                      {facilities
                        .filter((facility) => facility.text.toLowerCase().includes(facilitySearchTerm.toLowerCase()))
                        .map((facility) => (
                          <div key={facility.id} className="gis-facility-row" onClick={() => toggleFacilitySelect(facility.id)}>
                            <input type="checkbox" checked={facility.selected} onChange={() => toggleFacilitySelect(facility.id)}
                              onClick={(e) => e.stopPropagation()}
                              style={{ width: "13px", height: "13px", cursor: "pointer", accentColor: tokens.accentColor, flexShrink: 0 }} />
                            <span style={{ color: "#b8860b", flexShrink: 0 }}>⚡</span>
                            <span style={{ color: tokens.textPrimary, lineHeight: "1.3", fontSize: "11.5px" }}>{facility.text}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              {/* ── Distance Search Card: KM Range + Buttons ── */}
              <div className="gis-card">
                <div className="gis-card-body">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "12px", fontWeight: "600", color: tokens.textPrimary, cursor: "pointer" }}>
                      <input type="checkbox" checked={isKilometerEnabled} onChange={(e) => setIsKilometerEnabled(e.target.checked)}
                        style={{ width: "14px", height: "14px", accentColor: tokens.accentColor }} />
                      Kilometer Range
                    </label>
                    <span style={{
                      fontSize: "12px",
                      fontWeight: "800",
                      color: tokens.accentColor,
                      background: tokens.accentLight,
                      padding: "3px 10px",
                      borderRadius: "8px",
                      minWidth: "28px",
                      textAlign: "center",
                    }}>{kilometerRange} km</span>
                  </div>
                  <input type="range" min="1" max="100" value={kilometerRange}
                    onChange={(e) => setKilometerRange(parseInt(e.target.value))}
                    style={{ width: "100%", accentColor: tokens.accentColor, height: "4px", marginBottom: "12px" }} />
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button className="gis-btn-fill" style={{ flex: 1 }} onClick={handleFacilitySearch}>
                      <Search size={12} /> Search Facilities
                    </button>
                    <button className="gis-btn-outline" style={{ flex: 0 }} onClick={clearFacilitySelections}>
                      Clear
                    </button>
                  </div>
                </div>
              </div>

              {/* ── Resource Data Card ── */}
              <div className="gis-card">
                <div className="gis-card-header" onClick={() => setshowresourcedata(!showresourcedata)}>
                  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>📦 Resources</span>
                  {showresourcedata ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                </div>
                {showresourcedata && (
                  <div className="gis-card-body">
                    <span className="gis-label">Resource Type</span>
                    <select className="gis-select" value={selectedType} onChange={handleSelectChange} style={{ marginBottom: "10px" }}>
                      <option value="">Select type</option>
                      {resourcedata.map((item, idx) => (
                        <option key={`resource-${idx}-${item.id}`} value={item.id}>{item.value}</option>
                      ))}
                    </select>
                    <button className="gis-btn-fill" style={{ width: "100%" }} onClick={() => searhdisresource()}>
                      <Search size={12} /> Search Resources
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          {/* ═══════════════════════════════════════════════════
              INCIDENT TAB
          ═══════════════════════════════════════════════════ */}
          {activeTab === "Incident" && (
            <>
              {/* Incident Selection Card */}
              <div className="gis-card">
                <div className="gis-card-header" style={{ cursor: "default" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                    <AlertTriangle size={13} /> Incident Manager
                  </span>
                  {selectedIncidentId && (
                    <span style={{
                      fontSize: "9px",
                      fontWeight: "700",
                      background: "rgba(16,185,129,0.25)",
                      color: "#10b981",
                      padding: "2px 8px",
                      borderRadius: "10px",
                      letterSpacing: "0.04em",
                    }}>ACTIVE</span>
                  )}
                </div>
                <div className="gis-card-body">
                  <span className="gis-label">Select Incident</span>
                  {(() => {
                    const incidentOptions = incidentdata.map((item) => ({ ...item, value: String(item.value) }));
                    const selectedOption = incidentOptions.find((opt) => opt.value === String(selectedIncidentId)) || null;
                    return (
                      <Select
                        classNamePrefix="incident-select"
                        options={incidentOptions}
                        value={selectedOption}
                        isClearable
                        isSearchable
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Search by Incident ID, Name, Date, District..."
                        noOptionsMessage={() => "No incidents match"}
                        filterOption={(option, inputValue) => {
                          const term = inputValue.trim().toLowerCase();
                          if (!term) return true;
                          const d = option.data;
                          return (
                            (d.incidentSeqId || "").toLowerCase().includes(term) ||
                            (d.label || "").toLowerCase().includes(term) ||
                            (d.districtName || "").toLowerCase().includes(term) ||
                            (d.incidentDateTime || "").toLowerCase().includes(term)
                          );
                        }}
                        formatOptionLabel={(option) => (
                          <div style={{ lineHeight: 1.35 }}>
                            <div style={{ fontSize: "12px", fontWeight: 600, color: tokens.textPrimary }}>
                              {option.incidentSeqId ? `${option.incidentSeqId} — ` : ""}{option.label}
                            </div>
                            <div style={{ fontSize: "10.5px", color: tokens.textMuted }}>
                              {[option.incidentDateTime, option.districtName].filter(Boolean).join(" · ")}
                            </div>
                          </div>
                        )}
                        onChange={(option, actionMeta) => {
                          // The dropdown's own "×" should ask for confirmation
                          // just like the "Clear Incident" button does, instead
                          // of clearing the selection immediately.
                          if (actionMeta.action === "clear") {
                            setShowClearIncidentConfirm(true);
                            return;
                          }
                          const newIncidentId = option ? option.value : "";
                          setSelectedIncidentId(newIncidentId);
                          setIsChecked(false);
                          setMapData((prev) => ({ ...prev, events: [] }));
                          setSupportPointsData([]);
                        }}
                        styles={{
                          container: (base) => ({ ...base, marginBottom: "12px" }),
                          control: (base, state) => ({
                            ...base,
                            minHeight: "38px",
                            borderRadius: "8px",
                            borderColor: state.isFocused ? tokens.accentColor : tokens.inputBorder,
                            boxShadow: state.isFocused ? `0 0 0 3px ${tokens.accentLight}` : "none",
                            backgroundColor: tokens.inputBg,
                            "&:hover": { borderColor: tokens.accentColor },
                          }),
                          menu: (base) => ({ ...base, zIndex: 30, fontSize: "12px" }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected ? tokens.accentColor : state.isFocused ? tokens.accentLight : "transparent",
                            color: state.isSelected ? "#fff" : tokens.textPrimary,
                            cursor: "pointer",
                          }),
                          placeholder: (base) => ({ ...base, color: tokens.textMuted, fontSize: "12px" }),
                          input: (base) => ({ ...base, color: tokens.textPrimary, fontSize: "12px" }),
                          singleValue: (base) => ({ ...base, color: tokens.textPrimary }),
                        }}
                      />
                    );
                  })()}

                  {selectedIncidentId ? (
                    <button
                      className="gis-btn-outline"
                      style={{ width: "100%", color: "#dc2626", borderColor: "#fecaca" }}
                      onClick={() => setShowClearIncidentConfirm(true)}
                    >
                      ✕ Clear Incident
                    </button>
                  ) : (
                    <div style={{
                      padding: "14px",
                      background: tokens.accentLight,
                      borderRadius: "8px",
                      textAlign: "center",
                      fontSize: "11.5px",
                      color: tokens.textSecondary,
                      lineHeight: "1.5",
                    }}>
                      <AlertTriangle size={18} style={{ marginBottom: "4px", opacity: 0.5 }} /><br />
                      Choose an incident from the dropdown to display affected regions, support points, and events on the map.
                    </div>
                  )}
                </div>
              </div>

              {/* Linked Modules Section */}
              <div className="gis-card" style={{ marginTop: "10px" }}>
                <div className="gis-card-header" style={{ cursor: "default", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "7px" }}>
                    <Link2 size={13} />
                    <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.06em", textTransform: "uppercase" }}>Linked Modules</span>
                  </span>
                </div>
                <div className="gis-card-body" style={{ padding: "4px 0" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "10px 14px",
                      cursor: "pointer",
                      borderRadius: "8px",
                      transition: "background 0.15s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = tokens.accentLight}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                    onClick={() => {
                      const incidentName = incidentdata.find(item => String(item.value) === String(selectedIncidentId))?.label || "";
                      navigate("/Disaster-acknowledgereport/resource-assign-list", {
                        state: { incidentId: selectedIncidentId, incidentName },
                      });
                    }}
                  >
                    <div style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "rgba(109,40,217,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      <Users size={15} color="#7c3aed" />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: "12px", fontWeight: "600", color: tokens.textPrimary, marginBottom: "2px" }}>
                        Resource Allocation List
                      </div>
                      <div style={{ fontSize: "10.5px", color: tokens.textMuted, lineHeight: "1.4" }}>
                        View deployed resources for this incident
                      </div>
                    </div>
                    <ChevronRight size={14} color={tokens.textMuted} style={{ flexShrink: 0 }} />
                  </div>

                  {/* Divider */}
                  <div style={{ borderTop: `1px solid ${tokens.borderColor || "#f0f0f0"}`, margin: "0 14px" }} />

                  {/* SOP Instance List */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "10px 14px",
                      cursor: "pointer",
                      borderRadius: "8px",
                      transition: "background 0.15s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = tokens.accentLight}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                    onClick={() => {
                      const incidentName = incidentdata.find(item => String(item.value) === String(selectedIncidentId))?.label || "";
                      navigate("/Disaster-acknowledgereport/view-sop/Sop-instance-list", {
                        state: { incidentId: selectedIncidentId, incidentName },
                      });
                    }}
                  >
                    <div style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "rgba(16,185,129,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      <FileText size={15} color="#10b981" />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: "12px", fontWeight: "600", color: tokens.textPrimary, marginBottom: "2px" }}>
                        SOP Instance List
                      </div>
                      <div style={{ fontSize: "10.5px", color: tokens.textMuted, lineHeight: "1.4" }}>
                        View SOP instances for this incident
                      </div>
                    </div>
                    <ChevronRight size={14} color={tokens.textMuted} style={{ flexShrink: 0 }} />
                  </div>
                </div>
              </div>

              {/* ── SOP & Resource Overview — scoped to the whole state until
                  an incident is selected, then scoped to just that incident. ── */}
              <div className="gis-card" style={{ marginTop: "10px", overflow: "hidden" }}>
                <div
                  style={{
                    padding: "10px 14px",
                    background: "linear-gradient(120deg, #1a3f6f 0%, #2E6DA4 100%)",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                  }}
                >
                  <span style={{ display: "flex", alignItems: "center", gap: "7px", color: "#fff" }}>
                    <PlayCircle size={13} />
                    <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                      SOP &amp; Resource Overview
                    </span>
                  </span>
                  <span style={{ fontSize: "9.5px", color: "rgba(255,255,255,0.75)", fontWeight: 600 }}>
                    {selectedIncidentId ? "This incident" : "State-wide"}
                  </span>
                </div>
                <div style={{ padding: "12px", background: tokens.cardBg }}>
                  {sopSummaryLoading ? (
                    <div style={{ padding: "16px", textAlign: "center", fontSize: "12px", color: tokens.textMuted }}>
                      Loading summary...
                    </div>
                  ) : (
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                      {[
                        { label: "Deployed Resources", value: sopInstanceSummary?.resourceSummary?.deployed, icon: Truck, color: "#2563EB", bg: "rgba(37,99,235,0.1)" },
                        { label: "Released Resources", value: sopInstanceSummary?.resourceSummary?.released, icon: PackageCheck, color: "#0891B2", bg: "rgba(8,145,178,0.1)" },
                        { label: "Active SOP", value: sopInstanceSummary?.sopSummary?.active, icon: PlayCircle, color: "#D97706", bg: "rgba(217,119,6,0.1)" },
                        { label: "Cancelled SOP", value: sopInstanceSummary?.sopSummary?.cancel, icon: XCircle, color: "#DC2626", bg: "rgba(220,38,38,0.1)" },
                        { label: "Completed SOPs", value: sopInstanceSummary?.sopSummary?.completed, icon: CheckCircle2, color: "#059669", bg: "rgba(5,150,105,0.1)" },
                      ].map((stat) => (
                        <div
                          key={stat.label}
                          style={{
                            display: "flex", alignItems: "center", gap: "10px",
                            padding: "10px", borderRadius: "10px",
                            background: tokens.sectionBodyBg, border: tokens.cardBorder,
                          }}
                        >
                          <div style={{
                            width: "34px", height: "34px", borderRadius: "9px", background: stat.bg,
                            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                          }}>
                            <stat.icon size={16} color={stat.color} />
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: "16px", fontWeight: 800, color: tokens.textPrimary, lineHeight: 1.1 }}>
                              {stat.value ?? 0}
                            </div>
                            <div style={{ fontSize: "9.5px", color: tokens.textMuted, fontWeight: 600, lineHeight: 1.3, wordBreak: "break-word" }}>
                              {stat.label}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          {/* ═══════════════════════════════════════════════════
              ALERTS TAB
          ═══════════════════════════════════════════════════ */}
          {activeTab === "Alerts" && (
            <RecentAlerts
              weatherData={alertsWeatherData}
              capitalName={alertsCapitalName}
              stateName={statename || ""}
              weatherLoading={alertsWeatherLoading}
              stateId={stateId}
              alwaysExpanded={true}
            />
          )}

          </div>
        </div>
      </div>

      {showClearIncidentConfirm && (
        <div
          onClick={() => setShowClearIncidentConfirm(false)}
          style={{
            position: "fixed", inset: 0, zIndex: 5000,
            background: "rgba(15,26,46,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: tokens.cardBg, borderRadius: "12px", width: "320px",
              boxShadow: tokens.shadow, overflow: "hidden", fontFamily: "'Poppins', 'Segoe UI', sans-serif",
            }}
          >
            <div style={{ padding: "16px 18px 0", display: "flex", alignItems: "flex-start", gap: "12px" }}>
              <span style={{
                width: "34px", height: "34px", borderRadius: "50%", background: "#FEE2E2",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "16px",
              }}>
                ⚠️
              </span>
              <div>
                <div style={{ fontSize: "14px", fontWeight: 700, color: tokens.textPrimary }}>Clear Incident?</div>
                <div style={{ fontSize: "12px", color: tokens.textSecondary, marginTop: "4px", lineHeight: 1.4 }}>
                  This removes the selected incident and its markers from the map. This can't be undone.
                </div>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", padding: "16px 18px", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowClearIncidentConfirm(false)}
                style={{
                  padding: "8px 16px", borderRadius: "8px", border: `1.5px solid ${tokens.inputBorder}`,
                  background: "transparent", color: tokens.textPrimary, fontSize: "12.5px", fontWeight: 600, cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmClearIncident}
                style={{
                  padding: "8px 16px", borderRadius: "8px", border: "none",
                  background: "#dc2626", color: "#fff", fontSize: "12.5px", fontWeight: 600, cursor: "pointer",
                }}
              >
                Clear Incident
              </button>
            </div>
          </div>
        </div>
      )}
    </FullScreen>
  );
};

export default GisMapview;